export default "__VITE_ASSET__CaQNkYxs__"